import * as RadixCheckbox from '@radix-ui/react-checkbox'
import { CheckIcon, MinusIcon } from '@heroicons/react/20/solid'

export default function Checkbox({
  checked,
  disabled,
  onCheckedChange,
}: {
  checked: boolean | 'indeterminate'
  disabled?: boolean
  onCheckedChange: (checked: boolean | 'indeterminate') => void
}) {
  return (
    <RadixCheckbox.Root
      checked={checked}
      disabled={disabled}
      onCheckedChange={onCheckedChange}
      className="flex h-4 w-4 shrink-0 items-center justify-center rounded border border-border-strong bg-surface-field data-[state=checked]:border-brand-500 data-[state=checked]:bg-brand-500 data-[state=indeterminate]:border-brand-500 data-[state=indeterminate]:bg-brand-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500 disabled:cursor-default"
    >
      <RadixCheckbox.Indicator>
        {checked === 'indeterminate' ? (
          <MinusIcon aria-hidden className="h-3.5 w-3.5 text-white" />
        ) : (
          <CheckIcon aria-hidden className="h-3.5 w-3.5 text-white" />
        )}
      </RadixCheckbox.Indicator>
    </RadixCheckbox.Root>
  )
}
